<template>
  <div class="examineBox">
    <self-back :pageHeaderList="[{ 'name': `${$route.path == '/invoiceExamine' ? '发票审核' : '我的发票申请'}` }]"></self-back>
    <div class="containter" v-loading='loading'>
      <div class="topOperation clear">
        <span class="title">{{ $route.path == '/invoiceExamine' ? '发票审核' : '我的发票申请' }}</span>
        <div style="float:right">
          <el-select style="width:160px" @change="getInvoiceList(1)" v-model="voided_status" size='mini' :clearable='true'
            filterable placeholder="请选择作废状态">
            <el-option v-for="(item, index) in voidedList" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="company" @change="getInvoiceList(1)" style="width:150px;margin-right:15px;" size="mini"
            clearable placeholder="签约公司">
            <el-option v-for="(item, index) in companyList" :key="index" :label="item.company" :value="item.company">
            </el-option>
          </el-select>
          <label style="font-size:13px">财务审核时间：</label>
          <el-date-picker @change="getInvoiceList(1)" style="width:240px" v-model="approved_date" type="daterange"
            value-format="yyyy-MM-dd" size='mini' range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
          <template v-if="userInfo.role_id == 10 || userInfo.role_id == 18">
            <el-select v-model="pre_audit_status" @change="getInvoiceList(1)" style="width:150px;margin-right:15px;" size="mini"
              clearable placeholder="发票预审状态">
              <el-option v-for="(item, index) in pre_audit_list" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-select v-model="voided_pre_audit_status" @change="getInvoiceList(1)" style="width:150px;margin-right:15px;" size="mini"
              clearable placeholder="发票作废预审状态">
              <el-option v-for="(item, index) in pre_audit_list" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </template>
        </div>
      </div>
      <div style="margin: 0 16px 16px;">
        <el-select v-model="status" @change="getInvoiceList(1)" size="mini" clearable placeholder="开票状态">
          <el-option v-for="(item, index) in userInfo.role_id == 10 ? statusListCW : statusList" :key="index"
            :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-date-picker @change="getInvoiceList(1)" style="width:240px" v-model="invoice_date_range" type="daterange" size="mini"
          value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开票开始日期" end-placeholder="开票结束日期">
        </el-date-picker>
        <el-input placeholder="请输入客户全称" v-model.trim="customer_name" clearable
          @keydown.enter.native="customer_name ? getInvoiceList(1) : ''" @clear="getInvoiceList(1)" size="mini"
          style="width:200px">
          <el-button slot="append" icon="el-icon-search" @click="customer_name ? getInvoiceList(1) : ''"
            style="padding:0 10px"></el-button>
        </el-input>

        <el-input placeholder="请输入发票序列号" v-model.trim="serial_number" clearable
          @keydown.enter.native="serial_number ? getInvoiceList(1) : ''" @clear="getInvoiceList(1)" size="mini"
          style="width:200px">
          <el-button slot="append" icon="el-icon-search" @click="serial_number ? getInvoiceList(1) : ''"
            style="padding:0 10px"></el-button>
        </el-input>
        <el-input placeholder="请输入结算单序列号" v-model.trim="statements_id" clearable
          @keydown.enter.native="statements_id ? getInvoiceList(1) : ''" @clear="getInvoiceList(1)" size="mini"
          style="width:200px">
          <el-button slot="append" icon="el-icon-search" @click="statements_id ? getInvoiceList(1) : ''"
            style="padding:0 10px"></el-button>
        </el-input>
        <label style="font-size:13px" v-if="special_role">回款日期：</label>
        <el-date-picker @change="getInvoiceList(1)" style="width:240px" v-model="collection_date" type="daterange"
          value-format="yyyy-MM-dd" size='mini' range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" 
          v-if="special_role"/>
        <div class="refreshIcon batchDelete" @click="getInvoiceList(page)">
          刷新
          <i class="el-icon-refresh"></i>
        </div>
        <div class="batchDelete" @click="exportOrderDetails" v-if="[10, 1, 12].includes(userInfo.role_id) && $route.path == '/invoiceExamine'">
          导出订单明细
        </div>
      </div>
      <div class="listBox">
        <el-table class="table" :header-cell-style="{ background: '#f5f7fa' }" :data="accountList"
          height="calc(100vh - 294px)" border>
          <el-table-column prop="id" label="序列号" align='center' width="70"></el-table-column>
          <el-table-column prop="customer_name" label="客户名称" align='center' width="100"></el-table-column>
          <el-table-column prop="invoice_amount" align='center' label="开票金额"></el-table-column>
          <el-table-column prop="applicant_time" align='center' label="申请日期" width="96px"></el-table-column>
          <el-table-column prop="handler" align='center' label="申请人"></el-table-column>
          <el-table-column prop="company" align='center' label="签约公司" min-width="96px"></el-table-column>
          <el-table-column prop="invoiced_time" align='center' label="开票日期" width="96px"></el-table-column>
          <el-table-column v-if="special_role" align='center' label="回款日期" width="96px">
            <template slot-scope="scope">
              <div v-for="(item,index) of scope.row.collection_list">
                <span>{{ item['date_of_collection'] }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column align='center' label="是否作废" min-width="70">
            <template slot-scope="scope">
              <img v-if="scope.row.is_voided == 1" src="@/assets/img/voided.png"
                style="width:40px;height:29px;margin:auto" alt="">
            </template>
          </el-table-column>
          <el-table-column prop="voided_inv_id" align='center' label="作废发票序列号" min-width="110px"></el-table-column>
          <el-table-column prop="verify_at" width="96px" align='center' label="商务审核时间"></el-table-column>
          <el-table-column prop="confirm_verify_at" width="96px" align='center' label="财务审核时间"></el-table-column>
          <el-table-column align='center' label="作废状态" width="96px" fixed="right">
            <template slot-scope="scope">
              <span v-if="scope.row.voided_status == 1" style="color:#EF7400">待商务审核</span>
              <span v-if="scope.row.voided_status == 2" style="color:#EF7400">待财务审核</span>
              <span v-if="scope.row.voided_status == 3" style="color:#EF7400">商务审核驳回</span>
              <span v-if="scope.row.voided_status == 4" style="color:#00BB5D">财务审核通过</span>
              <span v-if="scope.row.voided_status == 5" style="color:#d51313">财务审核驳回</span>
            </template>
          </el-table-column>
          <el-table-column min-width="96px" align="center" label="预审结果" fixed="right" v-if="userInfo.role_id == 18 || userInfo.role_id == 10">
            <template slot-scope="scope">
              <div>
                <div v-if="scope.row.voided_pre_audit_status">
                  作废:<span v-if="scope.row.voided_pre_audit_status == 1" style="color:#00BB5D">通过</span><span v-if="scope.row.voided_pre_audit_status == 2" style="color:#d51313">驳回
                    <el-popover placement="left-end" title="发票作废预审意见" width="400" trigger="hover" :content="scope.row.voided_pre_audit_content">
                      <i class="el-icon-view" slot="reference" style="color: #202652;"></i>
                    </el-popover>
                  </span>
                </div>
                <div v-if="scope.row.pre_audit_status">
                  发票:<span v-if="scope.row.pre_audit_status == 1" style="color:#00BB5D">通过</span><span v-if="scope.row.pre_audit_status == 2" style="color:#d51313">驳回
                    <el-popover placement="left-end" title="发票预审意见" width="400" trigger="hover" :content="scope.row.pre_audit_content">
                      <i class="el-icon-view" slot="reference" style="color: #202652;"></i>
                    </el-popover>
                  </span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column align='center' label="状态" width="96px" fixed="right" >
            <template slot-scope="scope">
              <span v-if="scope.row.status == 1" style="color:#EF7400">待商务审核</span>
              <span v-if="scope.row.status == 2" style="color:#EF7400">待财务审核</span>
              <span v-if="scope.row.status == 3" style="color:#EF7400">商务审核驳回</span>
              <span v-if="scope.row.status == 4" style="color:#00BB5D">财务审核通过</span>
              <span v-if="scope.row.status == 5" style="color:#d51313">财务审核驳回</span>
              <span v-if="scope.row.status == 6" style="color:#fc726d">财务发票撤销</span>
            </template>
          </el-table-column>
          <el-table-column v-if="special_role" prop="collection_remark" align='center' label="回款备注" fixed="right"></el-table-column>
          <el-table-column align='center' label="操作" width="96px" fixed="right" >
            <template slot-scope="scope">
              <button class="detailButton" @click="goDetail(scope.row)">申请详情</button>
              <!-- 我的发票申请页面撤回按钮 -->
              <button class="detailButton" style="background:#fc726d"
                v-if="($route.path == '/myInvoiceApply') && (scope.row.status == 1 || scope.row.status == 2)"
                @click="invoiceWithdraw(scope.row)">发票撤回</button>
              <button class="detailButton"
                v-if="special_role && scope.row.status == 4 && scope.row.is_voided != 1" @click="extraUpdate(scope.row)">回款信息</button>
            </template>
          </el-table-column>
        </el-table>
        <div class="paginationBox">
          <el-pagination small background :current-page="page" :page-size="page_size"
            @current-change="handleCurrentChange" layout="total, prev, pager, next, jumper" :total="total" />
        </div>
      </div>
    </div>
    <!-- 撤销 -->
    <el-dialog title="撤销发票" :visible.sync="invoiceFlag" width="30%" :close-on-click-modal='false' center>
      <div class="dialogBox" v-loading='invoiceLoading'>
        <div class="dialogitem">
          <label>撤销理由：</label>
          <el-input style="margin-top:10px;width:100%" type="textarea" :rows="2" placeholder="请输入撤销理由"
            v-model="verify_note">
          </el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="invoiceFlag = false; verify_note = ''; invoice_id = ''" size="mini">取消</el-button>
        <el-button type="primary" @click="invoiceCancel()" size="mini">发票撤销</el-button>
      </span>
    </el-dialog>
    <!-- 回款编辑 -->
    <el-dialog title="编辑回款日期" :visible.sync="extraUpdateFlag" width="26%" :close-on-click-modal='false' center>
    <div class="dialogBox">
      <p style="font-size: 13px;line-height: 20px;color: #E6A23C;margin-left: 5px;">
        *仅会将距今最近的回款日期同步至订单
      </p>
      <div class="regulations">
        <p >序列号：{{ inv_id }}</p>
        <p >客户主体：{{ inv_customer_name }}</p>
      </div>
      <div class="regulations">
        <label>回款信息：</label>
        <div class="send-time-item">
          <div class="timeNums-wrap">
            <div class="timeNums" v-for="(item, idx) in collection_list" :key="idx">
              <el-date-picker style="width:48%;" v-model="item.date_of_collection" size="mini" value-format="yyyy-MM-dd" placeholder="请选择回款日期"/>
              <el-input style="width:47%;" v-model="item.collection_amount" size="mini" placeholder="请填写回款金额" @input="(val)=>{item.collection_amount=item.collection_amount.replace(/[^\d|.]/g,'');}"/>
              <i class="el-icon-error" @click="onClickDel(idx)" />
            </div>
          </div>
          <span class="add-btn" @click="onClickAdd"><i class="el-icon-circle-plus-outline"/>新增</span>
        </div>
      </div>
      <div class="regulations">
        <label>回款备注：</label>
        <div class="send-time-item">
          <el-input type="textarea" placeholder="请输入回款备注" v-model="collection_remark" style="width: 99%;" size="small" :rows="3" maxlength="500" clearable/>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="extraUpdateCancel" size="mini">取 消</el-button>
      <el-button type="primary" @click="extraUpdateConfirm" size="mini">确 定</el-button>
    </span>
  </el-dialog>
  </div>
</template>
<script>
export default {
  data () {
    return {
      serial_number: '',
      detailFlag: false,
      page: 1,
      page_size: 20,
      total: 0,
      loading: false,
      tab: 0,
      accountList: [],
      status: '',
      statusList: [
        { value: 1, label: '待商务审核' },
        { value: 2, label: '待财务审核' },
        { value: 3, label: '商务审核驳回' },
        { value: 4, label: '财务审核通过' },
        { value: 5, label: '财务审核驳回' },
        { value: 6, label: '财务发票撤销' },
      ],
      statusListCW: [
        { value: 2, label: '待财务审核' },
        { value: 4, label: '财务审核通过' },
        { value: 5, label: '财务审核驳回' },
        { value: 6, label: '财务发票撤销' },
      ],
      voidedList: [
        { value: 1, label: '待商务审核' },
        { value: 2, label: '待财务审核' },
        { value: 3, label: '商务审核驳回' },
        { value: 4, label: '财务审核通过' },
        { value: 5, label: '财务审核驳回' },
        { value: 6, label: '财务发票撤销' },
      ],
      invoice_date_range: [],// 开票日期筛选
      collection_date: '',// 回款日期筛选
      customer_name: '',
      invoice_id: '',
      inv_id: '',
      inv_customer_name: '',
      date_of_collection: '',
      userInfo: {},
      voided_status: '',
      approved_date: [],
      invoiceFlag: false,
      invoiceLoading: false,
      extraUpdateFlag: false,
      verify_note: '',
      companyList: [],
      company: '',
      statements_id: '',
      pre_audit_status: '',
      voided_pre_audit_status: '',
      pre_audit_list: [
        { label: '待审核', value: 0 },
        { label: '审核通过', value: 1 },
        { label: '审核驳回', value: 2 },
      ],
      collection_list: [ //回款信息
        { date_of_collection: "", collection_amount: "" }
      ],
      collection_remark: "",
      special_role: false,// 是否为商务助理特殊角色
    }
  },
  created () {
    this.userInfo = JSON.parse(this.$cookie.getCookie('userInfo'));
    this.getCompany()
    this.getInvoiceList(1)
    if(this.userInfo.role_id == 12 || this.userInfo.admin_id == 53 || this.userInfo.role_id == 15 || this.userInfo.role_id == 22) this.special_role = true
  },
  mounted () {
  },
  methods: {
    invoiceWithdraw (row) {//发票撤回
      this.$confirm('确定要撤销此次申请', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$loading(this.$loadingConfig);
        this.$axios.post(this.URL.BASEURL + this.URL.invoiceWithdraw, {
          id: row.id
        }).then((res) => {
          this.$loading(this.$loadingConfig).close();
          var res = res.data;
          if (res && res.errno == 0) {
            this.getInvoiceList(this.page)
          } else {
            this.$message({
              message: res.err,
              type: 'warning'
            })
          }
        }).catch(() => {
          this.$loading(this.$loadingConfig).close();
        })
      }).catch((action) => {
      });
    },
    extraUpdate (row) {
      this.inv_id = row.id
      this.inv_customer_name = row.customer_name
      this.collection_list = row.collection_list
      this.collection_remark = row.collection_remark

      if(this.collection_list.length == 0) {
        this.collection_list = [
          { date_of_collection: "", collection_amount: "" }
        ]
      }

      this.extraUpdateFlag = true;
    },
    invoiceCancel () {//财务发票撤销
      if (this.verify_note == '' || !this.verify_note) {
        this.$message({
          message: '请输入撤销理由',
          type: 'warning'
        })
        return
      }
      this.invoiceLoading = true;
      this.$axios.post(this.URL.BASEURL + this.URL.invoiceCancel, {
        id: this.invoice_id,
        verify_note: this.verify_note
      }).then((res) => {
        this.invoiceLoading = false;
        var res = res.data;
        if (res && res.errno == 0) {
          this.invoice_id = ''
          this.verify_note = ''
          this.invoiceFlag = false
          this.getInvoiceList(this.page)
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.invoiceLoading = false;
      })
    },
    goDetail (data) {
      this.invoice_id = data.id;
      if (this.$route.path == '/invoiceExamine') {
        let routeData = this.$router.resolve({
          path: '/invoiceExamineDetail/' + this.invoice_id,
        })
        this.$winopen(routeData.href)
      } else {
        let routeData = this.$router.resolve({
          path: '/invoiceDetail/' + this.invoice_id,
        })
        this.$winopen(routeData.href)
      }

      // this.detailFlag = true;
    },
    handleCurrentChange (val) {
      this.getInvoiceList(val)
    },
    exportOrderDetails() {
      if (!this.invoice_date_range || this.invoice_date_range.length === 0) {
        this.$message({
          message: '请选择开票日期范围',
          type: 'warning'
        });
        return;
      }
      this.$loading(this.$loadingConfig);
      this.$axios.get(this.URL.BASEURL + this.URL.invoiceOrderExport, {
        params: {
          id: this.serial_number,
          customer_name: this.customer_name,
          status: this.status,
          cdate_start: this.invoice_date_range && this.invoice_date_range.length > 0 ? this.invoice_date_range[0] : '',
          cdate_end: this.invoice_date_range && this.invoice_date_range.length > 0 ? this.invoice_date_range[1] : '',
          voided_status: this.voided_status,
          approved_start_date: this.approved_date && this.approved_date.length > 0 ? this.approved_date[0] : '',
          approved_end_date: this.approved_date && this.approved_date.length > 0 ? this.approved_date[1] : '',
          company: this.company,
          statements_id: this.statements_id,
          pre_audit_status: this.pre_audit_status,
          voided_pre_audit_status: this.voided_pre_audit_status,
          collection_date_start: this.collection_date && this.collection_date.length > 0 ? this.collection_date[0] : '',
          collection_date_end: this.collection_date && this.collection_date.length > 0 ? this.collection_date[1] : ''
        },
        responseType: 'blob'
      }).then((res) => {
        this.$loading(this.$loadingConfig).close();
        if (res.data.type === 'application/json') {
          const reader = new FileReader();
          reader.onload = () => {
             const result = JSON.parse(reader.result);
             this.$message({
                message: result.err || '导出失败',
                type: 'warning'
             })
          };
          reader.readAsText(res.data);
          return;
        }
        const content = res.data;
        const blob = new Blob([content]);
        const fileName = `订单明细_${this.invoice_date_range[0]}至${this.invoice_date_range[1]}.xlsx`
        if ('download' in document.createElement('a')) {
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          navigator.msSaveBlob(blob, fileName)
        }
      }).catch((err) => {
        console.error(err)
        this.$loading(this.$loadingConfig).close();
        this.$message({
          message: '导出请求异常',
          type: 'error'
        });
      })
    },
    getInvoiceList (page) {
      this.loading = true;
      this.page = page
      this.$axios.get(this.URL.BASEURL + this.URL.invoiceList, {
        params: {
          id: this.serial_number,
          page: page,
          pagesize: this.page_size,
          customer_name: this.customer_name,
          status: this.status,
          cdate_start: this.invoice_date_range && this.invoice_date_range.length > 0 ? this.invoice_date_range[0] : '',
          cdate_end: this.invoice_date_range && this.invoice_date_range.length > 0 ? this.invoice_date_range[1] : '',
          voided_status: this.voided_status,
          approved_start_date: this.approved_date && this.approved_date.length > 0 ? this.approved_date[0] : '',
          approved_end_date: this.approved_date && this.approved_date.length > 0 ? this.approved_date[1] : '',
          company: this.company,
          statements_id: this.statements_id,
          pre_audit_status: this.pre_audit_status,
          voided_pre_audit_status: this.voided_pre_audit_status,
          collection_date_start: this.collection_date && this.collection_date.length > 0 ? this.collection_date[0] : '',
          collection_date_end: this.collection_date && this.collection_date.length > 0 ? this.collection_date[1] : ''
        }
      }).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          this.accountList = res.rst.data;
          this.total = res.rst.pageInfo.total;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
    getCompany () {
      this.$axios.get(this.URL.BASEURL + this.URL.signCompanyList, {
        params: {
          page: 1,
          pagesize: 999,
        }
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          this.companyList = res.rst.data;
        } else {
        }
      }).catch(() => {
      })
    },
    extraUpdateCancel() {
      this.extraUpdateFlag = false
      this.collection_remark = ''
      this.collection_list = [
        { date_of_collection: "", collection_amount: "" }
      ]
    },
    extraUpdateConfirm () {//回款信息编辑
      for(let item of this.collection_list) {
        if((!item.date_of_collection || item.date_of_collection == '') && item.collection_amount) {
          this.$message({
            message: '请选择回款日期',
            type: 'warning'
          })
          return
        }

        if(item.date_of_collection && (!item.collection_amount || item.collection_amount == '')) {
          this.$message({
            message: '请输入回款金额',
            type: 'warning'
          })
          return
        }
      };
      
      // 若回款信息为空，弹框提醒
      if (this.collection_list.length == 1 && (!this.collection_list[0]['date_of_collection'] || this.collection_list[0]['date_of_collection'] == '')) {
        this.$confirm('空信息会将已有数据清除，请确认',{
          confirmButtonText: '确认提交',
          cancelButtonText: '取消',
          type: 'warning',
          showCancelButton: true,
          showClose: false,
          closeOnClickModal: false
        }).then(() => {
          this.$loading(this.$loadingConfig)
          this.updateCollectionContentRequest()
          this.$loading(this.$loadingConfig).close();
        }).catch(()=>{
          this.$loading(this.$loadingConfig).close();
        })

        return
      }
      
      this.$loading(this.$loadingConfig)
      this.updateCollectionContentRequest()
      this.$loading(this.$loadingConfig).close();
    },
    updateCollectionContentRequest() {
      this.$axios.post(this.URL.BASEURL + this.URL.collectionDataSave, {
        inv_id: this.inv_id,
        collection_list: this.collection_list,
        collection_remark: this.collection_remark,
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          this.extraUpdateFlag = false
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.getInvoiceList(1)
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {})
    },
    onClickDel(idx) {
      console.log('collection_list ==> ', this.collection_list);
      
      this.collection_list.splice(idx, 1);
      if(this.collection_list.length == 0) {
        this.collection_list = [
          { date_of_collection: "", collection_amount: "" }
        ]
      }
    },
    onClickAdd() {
      this.collection_list.push({date_of_collection:"", collection_amount: ""});
    }
  },
}
</script>
<style lang="scss" scoped>
/deep/.el-date-editor .el-range-separator {
  width: 20px;
}
.examineBox {
  .containter {
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 2px 6px 0px rgba(32, 38, 82, 0.1);

    .topOperation {
      padding: 16px;

      .title {
        font-size: 15px;
        color: #202652;
        line-height: 21px;
        font-weight: 500;
        display: inline-block;
        vertical-align: middle;
      }

      .selectBox {
        display: inline-block;
        vertical-align: middle;

        .selectItem {
          float: left;
          font-size: 13px;
          margin-left: 20px;
          cursor: pointer;

          .icon {
            width: 13px;
            height: 13px;
            border-radius: 3px;
            border: 1px solid #d2d2d2;
            display: inline-block;
            vertical-align: bottom;
            margin-right: 3px;
          }

          &.active {
            .icon {
              border-color: #2662ff;
              position: relative;

              &::before {
                content: "";
                display: inline-block;
                width: 7px;
                height: 7px;
                background: #2662ff;
                border-radius: 1px;
                position: absolute;
                top: 2px;
                left: 2px;
              }
            }
          }
        }
      }
    }
  }

  .table {
    width: calc(100% - 30px);
    margin: 0 15px;
  }

  .detailButton {
    min-width: 60px;
    height: 22px;
    background: #5b7bfe;
    border-radius: 4px;
    color: #ffffff;
    font-size: 12px;
    border: none;
    padding: 0 3px;
  }
}

.batchDelete {
  height: 24px;
  line-height: 24px;
  font-size: 12px;
  text-align: center;
  border-radius: 4px;
  border: 1px solid #5b7bfe;
  background: #5b7bfe;
  color: #fff;
  margin-right: 16px;
  cursor: pointer;
  padding: 0 4px;
  float: right;
}

.refreshIcon {
  margin-right: 10px;
  background: #67c23a;
  border-color: #67c23a;
}
</style>
<style lang="scss">
.el-date-editor .el-range-separator {
  width: auto;
}
.dialogitem {
    label {
      display: inline-block;
      width: 80px;
      font-size: 14px;
    }
    
    p {
      margin-top: 10px;
    }
  }
  .send-time-item {
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  margin-top: 10px;
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
  .el-radio {
    width: auto;
    margin-right: 0;
  }
  .text {
    flex-shrink: 0;
  }
  .el-input {
    margin: 0 6px 0 0;
    width: 80px;
    font-size: 13px;
  }
  .timeNums-wrap {
    .timeNums {
      margin-top: 6px;
      &:first-child {
        margin-top: 0;
      }
      .el-date-editor {
        width: 120px;
      }
      position: relative;
      .el-icon-error {
        position: absolute;
        right: 0px;
        top: -4px;
        color: #f56c6c;
        font-size: 14px;
        cursor: pointer;
      }
    }
  }
  .add-btn {
    margin-bottom: 6px;
    display: flex;
    align-items: center;
    font-size: 13px;
    color: #555;
    cursor: pointer;
    .el-icon-circle-plus-outline {
      margin-left: 10px;
      margin-right: 6px;
      font-size: 16px;
    }
  }
}

.regulations {
  margin-left: 5px;
  margin-top: 10px;
  .regulations-account {
    width: 365px;
    height: 40px;
    border-radius: 3px;
    border: 1px solid #dcdfe6;
    color: #383e47;
    font-size: 14px;
    line-height: 20px;
    padding: 0 7px;

    .icon {
      width: 25px;
      height: 25px;
      background: #43b083;
      border-radius: 4px;
      color: #ffffff;
      line-height: 25px;
      text-align: center;
      margin-right: 7px;
    }
  }

  .customer_all {
    background: #edf8fd;
    color: #383e47;
    font-size: 14px;
    line-height: 21px;
    padding: 6px 15px;
    margin-top: 10px;

    span {
      color: #43b083;
      font-weight: bold;
    }
  }

  p {
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newBilling/myInvoiceApply.vue